import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { QuoteDrawer } from "./QuoteDrawer";
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-318" data-mp="39w29q76y1fjc">
      <Header overHero={pathname === "/"} data-id="element-319" data-mp="3dv1dhogxv697" />
      <main className="flex-1" data-id="element-320" data-mp="3du00hegd49ou">
        <Outlet data-id="element-321" data-mp="3iunqbwsuukhh" />
      </main>
      <Footer data-id="element-322" data-mp="3itusjlbvj5bh" />
      <QuoteDrawer data-id="element-323" data-mp="3itkxhjbz27yx" />
    </div>;
}